export default class BarebonesProposalInfoAPIResponse {
  id?: string;
  error?: string;
  name?: string;
  description?: string;
  createdDate?: string;
}
